<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from './OfficeFurnitureFormData';
    import Select from '$components/Form/Select.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const entityTypeOptions = [
        `Entreprise privée`,
        `Administration ou collectivité`,
        `Établissement scolaire / santé`,
        `ONG / organisme international`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const furnitureTypeOptions = [
        `Bureaux (direction, opérateur, open space)`,
        `Chaises / fauteuils (de bureau, d’accueil, de réunion)`,
        `Armoires, rangements`,
        `Tables de réunion`,
        `Mobilier salle d’attente`,
        `Bibliothèques, casiers`,
        `Aménagement complet de bureau`,
        `Autre (précisez ci-dessous)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const volumeOptions = [
        `1 à 3 postes`,
        `4 à 10 postes`,
        `11 à 30 postes`,
        `Plus de 30 postes`,
        `Volume non défini`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row {form} field={fields.entityType} class="" let:field let:id label={`Vous êtes`}>
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={entityTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.furnitureTypes}
        class=""
        let:field
        let:id
        label={`Quels types de mobilier recherchez-vous ?`}
        helpLabel="Maximum 4 choix"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @xl:grid-cols-2 gap-x-8"
            choices={furnitureTypeOptions}
            max={4}
        />
    </Row>

    <Row
        {form}
        field={fields.volume}
        class=""
        let:field
        let:id
        label={`Volume estimé ou nombre de postes à équiper`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @xl:grid-cols-2 @3xl:grid-cols-3 gap-x-8"
            choices={volumeOptions}
        />
    </Row>
</div>
